import { infoStore, ParticipationStatus } from '../../../store/infoStore';
import { useDateHook } from '../../../hook/useDateHook';
import { End } from './End';
import { ActiveTicket } from './ActiveTicket';
import { InActiveTicket } from './InActiveTicket';

export const ProgressInfo = ({
  goMainEventTab,
  goOnlineTab,
}: {
  goMainEventTab: () => void;
  goOnlineTab: () => void;
}) => {
  const { info } = infoStore();
  const { isSatelliteEnd } = useDateHook();
  const isActiveTicket = info.status === ParticipationStatus.CHECK_ELIGIBLE;

  if (info.ticketCnt === 0) {
    // 조기 종료 여부 체크
    if (isSatelliteEnd()) {
      // 티켓이 없는 경우
      return <End goMainEventTab={goMainEventTab} />;
    } else {
      // 조기 종료
      return <End goMainEventTab={goMainEventTab} isEarlyEnd />;
    }
  }

  if (isSatelliteEnd()) {
    return <End goMainEventTab={goMainEventTab} />;
  }

  if (isActiveTicket)
    return <ActiveTicket goMainEventTab={goMainEventTab} ticketCnt={info.ticketCnt || 0} />;

  return <InActiveTicket goOnlineTab={goOnlineTab} ticketCnt={info.ticketCnt || 0} />;
};
